import { Box } from '@mui/material';
import type { ReactNode } from 'react';

/**
 * Parses a string containing **bold** markers and returns React nodes
 * where marked segments are wrapped in a bold span (fontWeight: 600),
 * consistent with inline bold emphasis used elsewhere in the AV domain.
 */
export function formatBoldText(text: string): ReactNode {
  const parts = text.split(/(\*\*.*?\*\*)/g);

  if (parts.length === 1) return text;

  return parts.map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      const boldContent = part.slice(2, -2);
      return (
        <Box key={index} component="span" sx={{ fontWeight: 600 }}>
          {boldContent}
        </Box>
      );
    }
    return part;
  });
}
